import classNames from 'classnames';

import { useSpacingBetweenProductCard } from '@/hooks';

import { Container } from '../Container';

import styles from './productslist.module.scss';
import ProductPlaceholder from '../Product/ProductPlaceholder';

const ProductListSkeleton = () => {
  const { spacingClass, isProductCardLargImage } =
    useSpacingBetweenProductCard();

  return (
    <Container
      className={classNames(styles.container, styles.skeleton_container)}
    >
      <div
        className={classNames(styles.content, spacingClass, {
          [styles.content__large]: isProductCardLargImage,
        })}
      >
        {new Array(20).fill(null).map((_, index) => (
          <ProductPlaceholder key={index} largeCard={isProductCardLargImage} />
        ))}
      </div>
    </Container>
  );
};

export { ProductListSkeleton };
